import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ModalBodyFullScroll } from './modalBodyFullScroll';
import { ModalBodySectionedScroll } from './modalBodySectionedScroll';
/**
 * The scrollable content area of the Modal. Has to be placed within `<ModalContent>`
 */ export const ModalBody = ({ scrollType = 'full', children, fixedSection, scrollableSection, styles, withFooter, onRefChanged })=>scrollType === 'full' ? /*#__PURE__*/ _jsx(ModalBodyFullScroll, {
        styles: styles,
        withFooter: withFooter,
        onRefChanged: onRefChanged,
        children: children
    }) : /*#__PURE__*/ _jsx(ModalBodySectionedScroll, {
        styles: styles,
        fixedSection: fixedSection,
        scrollableSection: scrollableSection
    });

//# sourceMappingURL=modalBody.js.map